import { WebgateConnect } from "./WebgateConnect";
export * from "./WebgateConnect";
export * from "./WebgateProvider";
export * from "../backend/server/shared-types";
export * from "../src/hooks";
export function connect(config) {
    return new WebgateConnect(config);
}
